import "./Contact.module.css";
import Encabezado from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import Ubicacion from "./sections/Ubicacion";
import FooterSection from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Encabezado />
      <ContactForm />
      <Ubicacion />
      <FooterSection />
    </div>;
}